import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Dialog, FormControlLabel, Grid, IconButton, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import axiosInstance, { EVENT_ID, getEventId, stripHtml, WEB_API } from '../constatns';
import TableToolBarCustom from '../components/MuiDataTableCustom/TableToolBarCustom';
import TableFilterList from '../components/MuiDataTableCustom/TableFilterList';
import TableToolbarSelect from '../components/MuiDataTableCustom/TableToolbarSelect';
// import PaperReviewJudgeAdd from './PaperReviewJudgeAdd';
import PaperReviewAssign from './PaperReviewAssign';
import {
  Delete,
  // HighlightOff
} from '@material-ui/icons';
import swal from '@sweetalert/with-react';
import FormControl from '@material-ui/core/FormControl';
import FreePaperSubmissionConfirm from '../freepaper/FreePaperSubmissionConfirm';
import ReviewWin from '../mypage/ReviewWin';
import Popout from 'react-popout-new';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      maxWidth: '200px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  radio: {
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
    },
    '& .MuiRadio-root': {
      padding: 3,
    },
  },
}));

const PaperReviewList = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [data, setData] = useState();
  const [alldata, setAllData] = useState();
  const [open, setOpen] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openReview, setOpenReview] = useState(false);
  const [selectData, setSelectData] = useState(false);
  const [selectFilter, setSelectFilter] = useState('all');
  const [selectRows, setSelectRows] = useState([]);
  const [paperId, setPaperId] = useState('');
  const [reviewerId, setReviewerId] = useState('');
  const [openResend, setOpenResend] = useState(false);
  const [openUrlResend, setOpenUrlResend] = useState('');

  const handleFilter = (_filter) => {
    setSelectFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else {
      const newData = alldata.filter((d) => {
        return d.presentationType === _filter;
      });
      setData(newData);
    }
  };

  let cols = [
    {
      name: 'id',
      label: 'No',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.tableData.length - tableMeta.rowIndex;
        },
      },
    },
    {
      name: 'paperRegNo',
      label: 'Abs No.(정렬)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // const _info = data[tableMeta.rowIndex];
          return value;
        },
      },
    },
    {
      name: 'abstractTitle',
      label: 'Title(정렬)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // const _info = data[tableMeta.rowIndex];
          return value;
        },
      },
    },
    {
      name: 'presentationType',
      label: 'Abstract Type(정렬)',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'id',
      label: '심사위원',
      options: {
        filter: true,
        // sort: true,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          // const item = data[tableMeta.rowIndex];
          return item.judge ? (
            <div>
              {item.judge.map((jd, idx) => {
                return (
                  <Grid key={'jd-' + idx} container direction={'row'} alignItems={'center'} justifyContent={'center'}>
                    <div onClick={() => showReview(value, jd)}>
                      {jd.in_name_en === jd.username ? jd.in_name_en : jd.in_name_en + ' (' + jd.username + ')'}
                    </div>
                    <IconButton aria-label="delete" onClick={() => setDeleteAssign(value, jd)}>
                      <Delete fontSize="small" />
                    </IconButton>
                  </Grid>
                );
              })}
            </div>
          ) : (
            ''
          );
        },
      },
    },
    {
      // name: 'totalScore',
      name: 'id',
      label: '총계',
      options: {
        filter: true,
        // sort: true,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          // const item = data[tableMeta.rowIndex];

          return item.judge ? (
            <div>
              {item.judge.map((jd, idx) => {
                const res = item.reviewResult ? item.reviewResult.find((r) => r.reviewer === jd.id) : null;
                let score = '';
                if (res) {
                  score = `${res.researchScore},${res.originalityScore},${res.concreteScore},${res.practicalityScore},${res.contributionScore}`;
                }
                return (
                  <Grid key={'totalScore-' + idx} container direction={'row'} alignItems={'center'} justifyContent={'center'}>
                    {res ? `${res.totalScore} (${score})` : '-'}
                    <IconButton aria-label="delete" style={{ visibility: 'hidden' }}>
                      <Delete fontSize="small" />
                    </IconButton>
                  </Grid>
                );
              })}
            </div>
          ) : (
            ''
          );
        },
      },
    },
    {
      // name: 'avg',
      name: 'id',
      label: '평균',
      options: {
        filter: true,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // const item = data[tableMeta.rowIndex];
          const item = data.find((f) => f.id === value);
          let total = 0;
          item.reviewResult &&
            item.reviewResult.map((res, idx) => {
              total += res.totalScore;
            });
          return item.reviewResult && item.reviewResult.length > 0 ? total / item.reviewResult.length : '-';
        },
      },
    },
    {
      name: 'id',
      // name: 'assignDate',
      label: '심사일',
      options: {
        filter: true,
        sort: false,
        viewColumns: false,
        download: false,

        customBodyRender: (value, tableMeta, updateValue) => {
          // const item = data[tableMeta.rowIndex];
          const item = data.find((f) => f.id === value);
          return item.judge ? (
            <div>
              {item.judge.map((jd, idx) => {
                const res = item.reviewResult ? item.reviewResult.find((r) => r.reviewer === jd.id) : null;

                return (
                  <Grid key={'totalScore-' + idx} container direction={'row'} alignItems={'center'} justifyContent={'center'}>
                    {res ? `${res.reviewDate ? moment(res.reviewDate).format('YYYY-MM-DD') : '-'}` : '-'}
                    <IconButton aria-label="delete" style={{ visibility: 'hidden' }}>
                      <Delete fontSize="small" />
                    </IconButton>
                  </Grid>
                );
              })}
            </div>
          ) : (
            ''
          );
        },
      },
    },
    {
      name: 'status',
      label: '제출상태(정렬)',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value;
          // const item = data[tableMeta.rowIndex];
          // const judge = item.judge ? item.judge.length : 0;
          // const reviewComplete = item.reviewResult ? item.reviewResult.filter((r) => r.reviewStatus === 'Complete') : [];
          // let reviewStatus = reviewComplete && judge === reviewComplete.length ? 'Complete' : 'In-Process';
          // if (judge === 0) {
          //   reviewStatus = 'In-Process';
          // }
          // const _color = reviewStatus === 'Complete' ? 'blue' : 'red';
          // return (
          //   <span style={{ color: _color }} onClick={(e) => console.log('')}>
          //     {reviewStatus}
          //   </span>
          // );
        },
      },
    },
    {
      // name: 'result',
      name: 'id',
      label: '채택여부 선택',
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // const item = data[tableMeta.rowIndex];
          const item = data.find((f) => f.id === value);
          const judge = item.judge ? item.judge.length : 0;
          const reviewComplete = item.reviewResult ? item.reviewResult.filter((r) => r.reviewStatus === 'Complete') : [];
          let reviewStatus = reviewComplete && judge === reviewComplete.length ? 'Complete' : 'In-Process';
          if (judge === 0) {
            reviewStatus = 'In-Process';
          }
          // if (
          //   item.id === 'paper_1631781541169' ||
          //   item.id === 'paper_1631781374876' ||
          //   item.id === 'paper_1631783668810' ||
          //   item.id === 'paper_1631783564340'
          // )
          //   reviewStatus = 'Complete';
          return reviewStatus === 'Complete' ? (
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="result"
                name="result"
                value={item.result || ''}
                className={classes.radio}
                onChange={(e) => setResult(item, e.target.value, updateValue, value)}
              >
                {/* {item.presentationType === 'Oral' && <FormControlLabel value="Oral" control={<Radio size={'small'} />} label="Oral 채택" />}
                {item.presentationType === 'E-Poster' && (
                  <FormControlLabel value="E-Poster" control={<Radio size={'small'} />} label="E-Poster 채택" />
                )} */}
                <FormControlLabel value="Oral" control={<Radio size={'small'} />} label="Oral 채택" />
                <FormControlLabel value="E-Poster" control={<Radio size={'small'} />} label="E-Poster 채택" />
                <FormControlLabel value="None" control={<Radio size={'small'} />} label="미채택" />
              </RadioGroup>
            </FormControl>
          ) : (
            ''
          );
        },
      },
    },

    {
      name: 'result',
      label: '채택결과(정렬)',
      options: {
        filter: false,
        sort: true,
        download: false,
      },
    },
    {
      name: 'id',
      label: 'Mail',
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // const item = data[tableMeta.rowIndex];
          const item = data.find((f) => f.id === value);
          if ((item.result && item.result === 'Oral') || item.result === 'E-Poster') {
            return (
              <>
                <Button
                  color={'primary'}
                  size={'small'}
                  variant={'contained'}
                  style={{ width: '60%', margin: '3px' }}
                  disableElevation
                  onClick={(e) => sendEmail(value, item)}
                >
                  Resend
                </Button>
                <Button
                  color={'secondary'}
                  size={'small'}
                  variant={'contained'}
                  style={{ width: '60%', margin: '3px', color: '#fff' }}
                  disableElevation
                  onClick={(e) => sendEmail(value, item, true)}
                >
                  Guideline
                </Button>
              </>
            );
          }
          if (item.result && item.result === 'None') {
            return (
              <>
                <Button
                  size={'small'}
                  variant={'contained'}
                  style={{ width: '60%', margin: '3px', backgroundColor: '#CD1039', color: '#fff', fontWeight: 900 }}
                  disableElevation
                  onClick={(e) => sendRejectEmail(value, item)}
                >
                  reject
                </Button>
              </>
            );
          } else {
            return '';
          }
        },
      },
    },
    {
      name: 'id',
      label: '심사결과View',
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // const item = data[tableMeta.rowIndex];
          const item = data.find((f) => f.id === value);
          const judge = item.judge ? item.judge.length : 0;
          const reviewComplete = item.reviewResult ? item.reviewResult.filter((r) => r.reviewStatus === 'Complete') : [];
          let reviewStatus = reviewComplete && judge === reviewComplete.length ? 'Complete' : 'In-Process';
          if (judge === 0) {
            reviewStatus = 'In-Process';
          }
          return reviewStatus === 'Complete' ? (
            <div style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={(e) => showView(value, item)}>
              View
            </div>
          ) : (
            ''
          );
        },
      },
    },
    /////////////////
    // {
    //   name: 'selectPresentingAuthorName',
    //   label: 'Presenting Name',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectPresentingAuthorInstitution',
    //   label: 'Presenting Institution',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectPresentingAuthorCountry',
    //   label: 'Presenting Country',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectPresentingAuthorEmail',
    //   label: 'Presenting Email',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectPresentingAuthorCategory',
    //   label: 'Presenting Category',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectPresentingAuthorMobile',
    //   label: 'Presenting Mobile',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'abstractTopic',
    //   label: 'Abstract Topic',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectCorrespondingAuthorName',
    //   label: 'Corresponding Name',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectCorrespondingAuthorInstitution',
    //   label: 'Corresponding Institution',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectCorrespondingAuthorCountry',
    //   label: 'Corresponding Country',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectCorrespondingAuthorEmail',
    //   label: 'Corresponding Email',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectCorrespondingAuthorCategory',
    //   label: 'Corresponding Category',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'selectCorrespondingAuthorMobile',
    //   label: 'Corresponding Mobile',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },

    // {
    //   name: 'purposeContent',
    //   label: 'Purpose',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'methodsContent',
    //   label: 'Methods',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'resultsContent',
    //   label: 'Results',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'conclusionContent',
    //   label: 'Conclusion',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'figures1',
    //   label: 'Figures 1',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'figures2',
    //   label: 'Figures 2',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'figures3',
    //   label: 'Figures 3',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'figures4',
    //   label: 'Figures 4',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'createdAt',
    //   label: '접수일',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       const dt = moment(Number(value));
    //       return dt.tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss');
    //     },
    //   },
    // },
    // {
    //   name: 'file',
    //   label: '발표파일',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return '-';
    //     },
    //   },
    // },
    // {
    //   name: 'isAgree1',
    //   label: 'Do you agree on changing your presentation type between oral presentation and E-Poster after acceptance?',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
    // {
    //   name: 'isAgree2',
    //   label: 'Copyright Agreement',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //     download: false,
    //   },
    // },
  ];

  const sendEmail = (val, item, isGuide) => {
    // console.log(item, 'sendItems item');
    let _url = `/#/admin/Resend?type=paperAccept&id=${val}`;
    if (isGuide) {
      _url = `/#/admin/Resend?type=paperGuide&id=${val}`;
    }
    setOpenUrlResend(`${_url}`);
    if (openResend) {
      setOpenResend(false);
      setTimeout(function () {
        setOpenResend(true);
      }, 300);
    } else {
      setOpenResend(true);
    }
  };

  const sendRejectEmail = (val, item) => {
    setOpenUrlResend(`/#/admin/Resend?type=paperReject&id=${val}`);
    if (openResend) {
      setOpenResend(false);
      setTimeout(function () {
        setOpenResend(true);
      }, 300);
    } else {
      setOpenResend(true);
    }
  };

  const setResult = (paper, _res, updateValue, orgValue) => {
    swal({
      title: '채택여부를 변경하시겠습니까?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const param = {
          evt: EVENT_ID,
          paperId: paper.id,
          result: _res,
        };
        axiosInstance.post(`${WEB_API}/paper/mod`, param).then((res) => {
          getPaperData();
        });
        // this.props.location.reload();
        // updateValue(_res);
      } else {
        if (orgValue && orgValue !== 'undefined') {
          updateValue(orgValue);
        } else updateValue('');
      }
    });
  };

  const showReview = (paperId, _judge) => {
    setReviewerId(_judge.id);
    setPaperId(paperId);
    setOpenReview(true);
  };
  const setDeleteAssign = (paperId, _judge) => {
    // console.log(paperId);
    // add reviewer
    swal({
      title: '정말 심사위원을 삭제하시겠습니까?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const param = {
          evt: EVENT_ID,
          paperId: paperId,
          judge: _judge,
        };
        axiosInstance.post(`${WEB_API}/paper/deleteAssign`, param).then((res) => {
          getPaperData();
        });
      }
    });
  };

  const onAssign = () => {
    setOpen(true);
  };

  const showView = (val, info) => {
    setSelectData(info);
    if (openView) {
      setOpenView(false);
      setTimeout(function () {
        setOpenView(true);
      }, 300);
    } else {
      setOpenView(true);
    }
  };

  const handleClose = (e, _judge) => {
    // console.log(_judge);
    setOpen(false);
    // add reviewer
    if (_judge && _judge.id) {
      const param = {
        evt: EVENT_ID,
        papers: selectRows,
        judge: _judge,
      };
      axiosInstance.post(`${WEB_API}/paper/assign`, param).then((res) => {
        getPaperData();
      });
    }
  };

  const handleCloseView = () => {
    setOpenView(false);
    setOpenReview(false);
  };

  const options = {
    print: false,
    search: true,
    searchOpen: true,
    filter: false,
    filterType: 'dropdown',
    viewColumns: false,
    selectableRows: 'multiple',
    downloadOptions: {
      filename: `Abstract_Review_${moment().valueOf()}.csv`,
    },
    onRowsDelete: () => {
      onAssign();
      return false;
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      let arr = [];
      allRowsSelected.map((row) => {
        arr.push(data[row.dataIndex].id);
      });
      setSelectRows([...arr]);
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      data.map((member) => {
        if (member.id === currentRow[0]) {
          for (const [key, value] of Object.entries(member)) {
            if (typeof value === 'string') {
              if (value.indexOf(searchQuery) !== -1) isFound = true;
            }
          }
        }
      });
      return isFound;
    },
    onDownload: (buildHead, buildBody, columns, _data) => {
      // console.log('columns: ', columns);
      // console.log('real data:', data);
      // console.log('_data:', _data);
      const maxReviewer = data.reduce(function (max, p) {
        return p.judge ? (p.judge.length > max ? p.judge.length : max) : max;
      }, 1);
      for (let i = 0; i < maxReviewer; i++) {
        columns.push({ name: `reviewer${i + 1}`, label: `심사위원 ${i + 1}`, download: true });
        columns.push({ name: `reviewer${i + 1}_score`, label: `총계 ${i + 1}`, download: true });
        columns.push({ name: `reviewer${i + 1}_date`, label: `심사일 ${i + 1}`, download: true });
      }

      columns.push({ name: `down_avg`, label: `평균`, download: true });
      columns.push({ name: `down_sts`, label: `Status`, download: true });
      columns.push({ name: `down_result`, label: '심사결과', download: true });

      // columns.push({name: 'paperRegNo', label: '접수번호', download: true});
      // columns.push({name: 'abstractNo', label: '초록번호', download: true});
      // columns.push({ name: 'status', label: '초록접수Status', download: true });
      columns.push({ name: 'writer', label: '작성자 ID', download: true });
      // columns.push({name: 'presentationType', label: 'Presentation Type', download: true});
      columns.push({ name: 'selectPresentingAuthorName', label: 'Presenting Name', download: true });
      columns.push({ name: 'selectPresentingAuthorInstitution', label: 'Presenting Institution', download: true });
      columns.push({ name: 'selectPresentingAuthorCountry', label: 'Presenting Country', download: true });
      columns.push({ name: 'selectPresentingAuthorEmail', label: 'Presenting Email', download: true });
      columns.push({ name: 'selectPresentingAuthorCategory', label: 'Presenting Category', download: true });
      columns.push({ name: 'selectPresentingAuthorMobile', label: 'Presenting Mobile', download: true });
      columns.push({ name: 'abstractTopic', label: 'Abstract Topic', download: true });
      columns.push({ name: 'selectCorrespondingAuthorName', label: 'Corresponding Name', download: true });
      columns.push({ name: 'selectCorrespondingAuthorInstitution', label: 'Corresponding Institution', download: true });
      columns.push({ name: 'selectCorrespondingAuthorCountry', label: 'Corresponding Country', download: true });
      columns.push({ name: 'selectCorrespondingAuthorEmail', label: 'Corresponding Email', download: true });
      columns.push({ name: 'selectCorrespondingAuthorCategory', label: 'Corresponding Category', download: true });
      columns.push({ name: 'selectCorrespondingAuthorMobile', label: 'Corresponding Mobile', download: true });
      columns.push({ name: 'purposeContent', label: 'Purpose', download: true });
      columns.push({ name: 'methodsContent', label: 'Methods', download: true });
      columns.push({ name: 'resultsContent', label: 'Results', download: true });
      columns.push({ name: 'conclusionContent', label: 'Conclusion', download: true });
      columns.push({ name: 'figures1', label: 'Figures 1', download: true });
      columns.push({ name: 'figures2', label: 'Figures 2', download: true });
      columns.push({ name: 'figures3', label: 'Figures 3', download: true });
      columns.push({ name: 'figures4', label: 'Figures 4', download: true });
      columns.push({ name: 'createdAt', label: '접수일', download: true });
      columns.push({ name: 'file', label: '발표파일', download: true });
      columns.push({
        name: 'isAgree1',
        label: 'Do you agree on changing your presentation type between oral presentation and E-Poster after acceptance?',
        download: true,
      });
      columns.push({ name: 'isAgree2', label: 'Copyright Agreement', download: true });

      // Author & Institution
      const maxAuthor = data.reduce(function (max, p) {
        return p.numOfAuthor.length > max ? p.numOfAuthor.length : max;
      }, data[0].numOfAuthor.length);
      const maxIns = data.reduce(function (max, p) {
        return p.numOfInstitution.length > max ? p.numOfInstitution.length : max;
      }, data[0].numOfInstitution.length);
      for (let i = 0; i < maxAuthor; i++) {
        columns.push({ name: `author${i + 1}`, label: `Author ${i + 1}`, download: true });
      }
      for (let j = 0; j < maxIns; j++) {
        columns.push({ name: `institution${j + 1}`, label: `Institution ${j + 1}`, download: true });
      }

      //////////////

      const avgIdx = columns.findIndex((d) => d.name === 'down_avg');
      const stsIdx = columns.findIndex((d) => d.name === 'down_sts');
      const resIdx = columns.findIndex((d) => d.name === 'down_result');
      ////
      const paperStatusIdx = columns.findIndex((d) => d.name === 'status');
      const writerIdx = columns.findIndex((d) => d.name === 'writer');
      const selectPresentingAuthor = columns.findIndex((d) => d.name === 'selectPresentingAuthorName');
      const selectPresentingAuthorInstitution = columns.findIndex((d) => d.name === 'selectPresentingAuthorInstitution');
      const selectPresentingAuthorCountry = columns.findIndex((d) => d.name === 'selectPresentingAuthorCountry');
      const selectPresentingAuthorEmail = columns.findIndex((d) => d.name === 'selectPresentingAuthorEmail');
      const selectPresentingAuthorCategory = columns.findIndex((d) => d.name === 'selectPresentingAuthorCategory');
      const selectPresentingAuthorMobile = columns.findIndex((d) => d.name === 'selectPresentingAuthorMobile');
      const abstractTopicIdx = columns.findIndex((d) => d.name === 'abstractTopic');
      const selectCorrespondingAuthor = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorName');
      const selectCorrespondingAuthorInstitution = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorInstitution');
      const selectCorrespondingAuthorCountry = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorCountry');
      const selectCorrespondingAuthorEmail = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorEmail');
      const selectCorrespondingAuthorCategory = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorCategory');
      const selectCorrespondingAuthorMobile = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorMobile');
      const purposeContent = columns.findIndex((d) => d.name === 'purposeContent');
      const methodsContent = columns.findIndex((d) => d.name === 'methodsContent');
      const resultsContent = columns.findIndex((d) => d.name === 'resultsContent');
      const conclusionContent = columns.findIndex((d) => d.name === 'conclusionContent');
      const figures1 = columns.findIndex((d) => d.name === 'figures1');
      const figures2 = columns.findIndex((d) => d.name === 'figures2');
      const figures3 = columns.findIndex((d) => d.name === 'figures3');
      const figures4 = columns.findIndex((d) => d.name === 'figures4');
      const createdAtIdx = columns.findIndex((d) => d.name === 'createdAt');
      const fileIdx = columns.findIndex((d) => d.name === 'file');
      const isAgree1 = columns.findIndex((d) => d.name === 'isAgree1');
      const isAgree2 = columns.findIndex((d) => d.name === 'isAgree2');

      ////

      let retVal = [];

      _data.map((_d) => {
        const _info = data[_d.index];

        let total = 0;
        _info.reviewResult &&
          _info.reviewResult.map((rs, idx) => {
            total += rs.totalScore;
          });

        const firstIdx = columns.findIndex((d) => d.name === 'reviewer1');
        for (let i = firstIdx; i < firstIdx + 3 * maxReviewer; i++) {
          _d.data[i] = '';
        }

        if (_info.judge) {
          for (let a = 0; a < _info.judge.length; a++) {
            const reviewer = _info.judge[a];
            const rvIdx = columns.findIndex((d) => d.name === 'reviewer' + (a + 1));
            const rvScoreIdx = columns.findIndex((d) => d.name === 'reviewer' + (a + 1) + '_score');
            const rvDateIdx = columns.findIndex((d) => d.name === 'reviewer' + (a + 1) + '_date');

            const res = _info.reviewResult ? _info.reviewResult.find((r) => r.reviewer === reviewer.id) : null;
            let score = '';
            if (res) {
              score = `${res.researchScore},${res.originalityScore},${res.concreteScore},${res.practicalityScore},${res.contributionScore}`;
            }

            if (rvIdx !== -1) {
              _d.data[rvIdx] = `${
                reviewer.in_name_en === reviewer.username ? reviewer.in_name_en : reviewer.in_name_en + ' (' + reviewer.username + ')'
              }`;
              _d.data[rvScoreIdx] = `${res ? res.totalScore + ' (' + score + ')' : ''}`;
              _d.data[rvDateIdx] = `${res ? moment(res.reviewDate).format('YYYY-MM-DD') : ''}`;
            }
          }
        }
        if (avgIdx !== -1) {
          _d.data[avgIdx] = `${_info.reviewResult ? total / _info.reviewResult.length : ''}`;
        }
        if (stsIdx !== -1) {
          _d.data[stsIdx] = `${_info.reviewResult ? (_info.reviewResult.length === _info.judge.length ? 'Complete' : '') : ''}`;
        }
        if (resIdx !== -1) {
          _d.data[resIdx] = `${_info.result ? `${_info.result} 채택` : ''}`;
        }

        /////
        // if (paperStatusIdx !== -1) {
        //   _d.data[paperStatusIdx] = `${_info.status ? _info.status : ''}`;
        // }

        ////////////////////////////////

        const selectPresenting = data[_d.index].selectPresentingAuthor;
        const findAuthor = _info.numOfAuthor.find((ah) => ah.id === selectPresenting);
        const findAuthorIns = _info.numOfInstitution.find((ah) => ah.id === findAuthor.ino1);
        const selectCorresponding = data[_d.index].selectCorrespondingAuthor;
        const findCorrespondingAuthor = _info.numOfAuthor.find((ah) => ah.id === selectCorresponding);
        const findCorrespondingAuthorIns = findCorrespondingAuthor
          ? _info.numOfInstitution.find((ah) => ah.id === findCorrespondingAuthor.ino1)
          : null;

        for (let a = 0; a < _info.numOfAuthor.length; a++) {
          const authorIdx = columns.findIndex((d) => d.name === 'author' + (a + 1));
          const author = _info.numOfAuthor[a];
          const authorIns = _info.numOfInstitution.find((ah) => ah.id === author.ino1);
          const isPresenting = author.id === findAuthor.id ? 'Y' : 'N';
          const isCorresponding = findCorrespondingAuthor && author.id === findCorrespondingAuthor.id ? 'Y' : 'N';
          if (authorIdx !== -1) {
            _d.data[
              authorIdx
            ] = `Name : ${author.firstName} ${author.lastName}\nInstitution : ${authorIns.affiliation}\nPresenting author : ${isPresenting}\nCorresponding Author : ${isCorresponding}`;
          }
        }
        for (let ins = 0; ins < _info.numOfInstitution.length; ins++) {
          const insIdx = columns.findIndex((d) => d.name === 'institution' + (ins + 1));
          const insInfo = _info.numOfInstitution[ins];
          if (insIdx !== -1) {
            _d.data[
              insIdx
            ] = `Department : ${insInfo.department}\nAffiliation : ${insInfo.affiliation}\nCity/State : ${insInfo.city}\nCountry : ${insInfo.country}`;
          }
        }

        ///////
        if (selectPresentingAuthor !== -1) {
          _d.data[selectPresentingAuthor] = findAuthor.firstName + ' ' + findAuthor.lastName;
        }
        if (selectPresentingAuthorInstitution !== -1) {
          _d.data[selectPresentingAuthorInstitution] = findAuthorIns.affiliation;
        }
        if (selectPresentingAuthorCountry !== -1) {
          _d.data[selectPresentingAuthorCountry] = findAuthor.country;
        }
        if (selectPresentingAuthorCategory !== -1) {
          _d.data[selectPresentingAuthorCategory] = findAuthor.category;
        }
        if (selectPresentingAuthorEmail !== -1) {
          _d.data[selectPresentingAuthorEmail] = findAuthor.email;
        }
        if (selectPresentingAuthorMobile !== -1) {
          _d.data[selectPresentingAuthorMobile] = findAuthor.phoneNumber;
        }

        if (abstractTopicIdx !== -1) {
          _d.data[abstractTopicIdx] = `${_info.abstractTopic ? _info.abstractTopic : ''}`;
        }

        if (selectCorrespondingAuthor !== -1) {
          _d.data[selectCorrespondingAuthor] = findCorrespondingAuthor
            ? findCorrespondingAuthor.firstName + ' ' + findCorrespondingAuthor.lastName
            : '';
        }
        if (selectCorrespondingAuthorInstitution !== -1) {
          _d.data[selectCorrespondingAuthorInstitution] = findCorrespondingAuthorIns ? findCorrespondingAuthorIns.affiliation : '';
        }
        if (selectCorrespondingAuthorCountry !== -1) {
          _d.data[selectCorrespondingAuthorCountry] = findCorrespondingAuthor ? findCorrespondingAuthor.country : '';
        }
        if (selectCorrespondingAuthorCategory !== -1) {
          _d.data[selectCorrespondingAuthorCategory] = findCorrespondingAuthor ? findCorrespondingAuthor.category : '';
        }
        if (selectCorrespondingAuthorEmail !== -1) {
          _d.data[selectCorrespondingAuthorEmail] = findCorrespondingAuthor ? findCorrespondingAuthor.email : '';
        }
        if (selectCorrespondingAuthorMobile !== -1) {
          _d.data[selectCorrespondingAuthorMobile] = findCorrespondingAuthor ? findCorrespondingAuthor.phoneNumber : '';
        }
        // if (paperStatusIdx !== -1) {
        //   _d.data[paperStatusIdx] = `${_info.status ? _info.status : ''}`;
        // }
        if (writerIdx !== -1) {
          _d.data[writerIdx] = `${_info.writer ? _info.writer.replace('evt029_', '') : ''}`;
        }
        if (createdAtIdx !== -1) {
          _d.data[createdAtIdx] = `${
            _info.createdAt ? moment(Number(_info.createdAt)).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss') : ''
          }`;
        }
        if (isAgree1 !== -1) {
          _d.data[isAgree1] = `${_info.isAgree1 ? _info.isAgree1 : ''}`;
        }
        if (isAgree2 !== -1) {
          _d.data[isAgree2] = `${_info.isAgree2 ? _info.isAgree2 : ''}`;
        }
        if (purposeContent !== -1) {
          _d.data[purposeContent] = stripHtml(_info.purposeContent);
        }
        if (methodsContent !== -1) {
          _d.data[methodsContent] = stripHtml(_info.methodsContent);
        }
        if (resultsContent !== -1) {
          _d.data[resultsContent] = stripHtml(_info.resultsContent);
        }
        if (conclusionContent !== -1) {
          _d.data[conclusionContent] = stripHtml(_info.conclusionContent);
        }
        if (figures1 !== -1) {
          _d.data[figures1] = _info.figures1 ? '=HYPERLINK("' + _info.figures1.path + '","' + _info.figures1.name + '")' : '';
        }
        if (figures2 !== -1) {
          _d.data[figures2] = _info.figures2 ? '=HYPERLINK("' + _info.figures2.path + '","' + _info.figures2.name + '")' : '';
        }
        if (figures3 !== -1) {
          _d.data[figures3] = _info.figures3 ? '=HYPERLINK("' + _info.figures3.path + '","' + _info.figures3.name + '")' : '';
        }
        if (figures4 !== -1) {
          _d.data[figures4] = _info.figures4 ? '=HYPERLINK("' + _info.figures4.path + '","' + _info.figures4.name + '")' : '';
        }
        if (fileIdx !== -1) {
          _d.data[fileIdx] = _info.file ? '=HYPERLINK("' + _info.file.path + '","' + _info.file.name + '")' : '';
        }

        retVal.push(_d);
        return _d;
      });
      //eslint-disable-next-line
      const body = buildBody(retVal).replace(/\'/gi, '');
      return '\uFEFF' + buildHead(columns) + body;
    },
  };

  const getPaperData = () => {
    // axiosInstance.get(`${WEB_API}/paper/list?eventId=${getEventId()}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
    //   const arrData = response.data.sort((a, b) => {
    //     return Number(b.createdAt) - Number(a.createdAt);
    //   });
    //   setData(arrData);
    //   setAllData(arrData);
    // });

    let final = [];
    function getServer(_lastKey) {
      let url = `${WEB_API}/paper/listSimple?eventId=${getEventId()}&limit=-1`;
      if (_lastKey) {
        url += `&lastKey=${encodeURIComponent(_lastKey.id)}&lastVal=${_lastKey.evt}&lastValName=evt`;
      }
      // console.log(url);
      axiosInstance
        .get(`${url}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((res) => {
          res.data.Items.forEach(function (itemdata) {
            final.push(itemdata);
          });

          if (typeof res.data.LastEvaluatedKey !== 'undefined') {
            // console.log(res.data.LastEvaluatedKey);
            getServer(res.data.LastEvaluatedKey);
          } else {
            const arrData = final.sort((a, b) => {
              return Number(b.createdAt) - Number(a.createdAt);
            });
            setData(arrData);
            setAllData(arrData);
          }
        });
    }
    getServer();
  };

  useEffect(() => {
    getPaperData();
  }, []);

  return (
    <Grid item xs={12}>
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={selectFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleFilter('all')}>
                  All Abstract
                </Button>
                <Button variant={selectFilter === 'Oral' ? 'contained' : 'outlined'} onClick={() => handleFilter('Oral')}>
                  Oral
                </Button>
                <Button variant={selectFilter === 'E-Poster' ? 'contained' : 'outlined'} onClick={() => handleFilter('E-Poster')}>
                  E-Poster
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginTop: 20 }}>
          <MUIDataTable
            title={''}
            data={data}
            columns={cols}
            options={options}
            components={{ TableToolbar: TableToolBarCustom, TableFilterList: TableFilterList, TableToolbarSelect: TableToolbarSelect }}
          />
        </Grid>
      </Grid>
      {open ? (
        <Dialog
          open={open}
          maxWidth={'lg'}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <PaperReviewAssign handleClose={handleClose} />
        </Dialog>
      ) : null}
      {openView ? (
        <Dialog
          open={openView}
          maxWidth={'lg'}
          onClose={handleCloseView}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <FreePaperSubmissionConfirm
            mode={'review'}
            abstractId={selectData.id}
            isPop={true}
            isAdmin={true}
            isAdminReview={true}
            infoData={selectData}
            data={selectData}
            handleClose={handleCloseView}
          />
        </Dialog>
      ) : null}
      {openReview ? (
        <Dialog
          open={openReview}
          maxWidth={'lg'}
          onClose={handleCloseView}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <ReviewWin abstractId={paperId} isAdmin={true} reviewerId={reviewerId} handleClose={handleCloseView} />
        </Dialog>
      ) : null}
      {openResend ? (
        <Popout url={openUrlResend} title="PRS2022-ADMIN-PAPERPRESEND" onClosing={handleClose} options={{ width: 850, height: 800 }} />
      ) : null}
    </Grid>
  );
};

export default PaperReviewList;
